import type { PlanDto } from '@dbrain/shared';

/**
 * 16c.2 (B2cFiyatlar2, B2cTanitim2): what the public pages work out of the two packages' settings. Nothing here
 * holds a number of its own. 16c.8 (D-440): the public pages name no model any more, so the strip's model rule
 * (D-375) is gone; `shortNames` stays for the Pro dialogs inside the app.
 */

/** "50 kat": how many times the free package's daily tokens Pro gives, when it is a whole number above one */
export function tokenTimes(free: Pick<PlanDto, 'dailyTokens'> | undefined, pro: Pick<PlanDto, 'dailyTokens'>): number | null {
  if (!free || free.dailyTokens <= 0) return null;
  const times = pro.dailyTokens / free.dailyTokens;
  return Number.isInteger(times) && times > 1 ? times : null;
}

/**
 * "Büyük, Orta, Hızlı": the names of Pro's own models with a shared last word ("model") left out, as the mockups
 * write them; names without one stay whole.
 */
export function shortNames(names: string[]): string {
  const words = names.map((name) => name.trim().split(/\s+/));
  const last = words[0]?.at(-1)?.toLocaleLowerCase('tr');
  const shared = names.length > 1 && last !== undefined && words.every((w) => w.length > 1 && w.at(-1)?.toLocaleLowerCase('tr') === last);
  return (shared ? words.map((w) => w.slice(0, -1).join(' ')) : names).join(', ');
}
